import { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { SourcePage } from '../../types/sourcePage.types';

export type SourcePageContextValues = {
  sourcePage: SourcePage;
};

export const SourcePageContext = createContext<
  SourcePageContextValues | undefined
>(undefined);

export type SourcePageProviderProps = {
  children: ReactNode;
  sourcePage: SourcePage;
};

export const SourcePageProvider = ({
  children,
  sourcePage,
}: SourcePageProviderProps) => {
  const sourcePageContextValues = useMemo(
    () => ({
      sourcePage,
    }),
    [sourcePage]
  );

  return (
    <SourcePageContext.Provider value={sourcePageContextValues}>
      {children}
    </SourcePageContext.Provider>
  );
};

export const useSourcePageContext = (): SourcePageContextValues => {
  const context = useContext(SourcePageContext);
  if (!context) {
    throw new Error(
      'useSourcePageContext must be used within a SourcePageProvider'
    );
  }
  return context;
};
